"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _components = require("@/components");
var _vuex = require("vuex");
var _apply = require("@/api/data/apply");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Dashboard',
  components: {
    PageInfo: _components.PageInfo
  },
  data: function data() {
    return {
      appList: [],
      pagination: {
        page: 1,
        limit: 100,
        total: 100
      },
      colorList: ['#43b0cb', '#428ae6', '#5a717f', '#5735aa'],
      bgColorList: ['#1f88a2c7', '#3870b8c7', '#2d323561', '#2b1366c7']
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['ticket', 'username'])),
  created: function created() {},
  mounted: function mounted() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;
      (0, _apply.getApplyList)(this.pagination).then(function (res) {
        _this.appList = res.data.list;
        console.log(_this.appList);
      });
    },
    enterSystem: function enterSystem(data) {
      // 打开新页面跳转
      console.log("".concat(data, "?ticket=").concat(this.ticket), '_blank');
      window.open("".concat(data, "?ticket=").concat(this.ticket), '_blank');
    }
  }
};
exports.default = _default;